/**
 * Javascript file for the page with details on the current technology. 
 * @author Adrian Rebmann, Yannik Sprengart, Eduardo Parducci, Andreas Emrich, Sebastian Grill, Steffen Schuhmann
 */

import {
  getTechnologyByHash,
  getBmasForTechnology,
  isCompanyRequestingTechByHash,
  removeCompanyRequestTechByHash,
  isCompanyOfferingTechByHash,
  addCompanyOfferTechByHash,
  removeCompanyOfferTechByHash,
  addCompanyRequestTechByHash
} from "../../../../api";

import auth from "../../../../auth";

// Import config from correct environment
var environment = process.env.NODE_ENV;
var config = require(`../../../../../config/${environment}.json`);

export default {
  name: "TechnologyDetail",
  props: ["hash"],

  /**
   * The vue instance's data object.
   * @property {boolean} loggedIn - Status of the user's login. 
   * @property {boolean} offer - The current offers for the technology.
   * @property {boolean} request - The current request for the technology.
   * @property {object} technology - The technology item.
   * @property {boolean} loading - Information is currently being processed.
   * @property {boolean} showDialog - Visibility of the "add this technology to your company's profile" dialog.
   * @property {any[]} bmarecommendations - The business model aspect recommendations.
   * @property {any[]} projects - The projects for the technology.
   * @property {boolean} adding - Information about the technology is currently being updated.
   * @property {string} imageLink - The base path for the image link.
   */
  data() {
    return {
      loggedIn: auth.loggedIn(),
      offer: false,
      request: false,
      technology: null,
      loading: false,
      showDialog: false,
      bmarecommendations: [],
      projects: [],
      adding: false,
      imageLink: `${config.deployment}/static/uploads/`,
    };
  },

  /**
   * Expressions to watch.
   */
  watch: {
    $route: "fetchData"
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.fetchData();
    console.log(imageLink);
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Check if there are any current offers for this technology.
     * @param {*} hash - The hash of the technology.
     */
    checkOffer(hash) {
      return isCompanyOfferingTechByHash(hash).then(res => {
        this.offer = res;
      });
    },
    
    /**
     * Check is there are any current requests for this technology.
     * @param {*} hash - The hash of the technology.
     */
    checkRequest(hash) {
      return isCompanyRequestingTechByHash(hash).then(res => {
        this.request = res;
      });
    },

    /**
     * Adds an offer for this tecnology.
     */
    addOffer() {
      this.adding = true;
      addCompanyOfferTechByHash(this.technology.hash).then(res => {
        this.checkOffer().then(() => {
          this.adding = false;
          this.showDialog = false;
        });
      });
    },

    /**
     * Removes an offer for this technology.
     */
    removeOffer() {
      this.adding = true;
      removeCompanyOfferTechByHash(this.technology.hash).then(res => {
        this.checkOffer().then(() => {
          this.adding = false;
          this.showDialog = false;
        });
      });
    },

    /**
     * Adds a request for this technology.
     */
    addRequest() {
      this.adding = true;
      addCompanyRequestTechByHash(this.technology.hash).then(res => {
        this.checkRequest().then(() => {
          this.adding = false;
          this.showDialog = false;
        });
      });
    },

    /**
     * Removes a request for this technology.
     */
    removeRequest() {
      this.adding = true;
      removeCompanyRequestTechByHash(this.technology.hash).then(res => {
        this.checkRequest().then(() => {
          this.adding = false;
          this.showDialog = false;
        });
      });
    },

    /**
     * Shortens the description.
     * @param {*} desc - The description.
     */
    shorten(desc) {
      var res = desc.substring(0, 300) + "...";
      return res;
    },

    /**
     * Retrieves the technology's data.
     */
    fetchData() {
      this.loading = true;
      this.technology = null;

      getTechnologyByHash(this.hash).then(res => {
        getBmasForTechnology(this.hash).then(bmatech => {
          for (let i = 0; i < bmatech.length; i++) {
            //Business model aspect recommendations
            this.bmarecommendations.push({
              name: bmatech[i].bma.name,
              description: bmatech[i].bma.description,
              hash: bmatech[i].bma.hash,
              weight: bmatech[i].weight
            });
          }
          this.bmarecommendations.sort(function (a, b) {
            if (a.weight < b.weight) {
              return -1;
            }
            if (a.weight > b.weight) {
              return 1;
            }
            return 0;
          });

          //If logged in, check for offers and requests for this technology.
          if (this.loggedIn) {
            this.checkOffer(this.hash).then(() => {
              this.checkRequest(this.hash).then(() => {
                this.technology = res;
                this.loading = false;
              });
            });
          } else {
            this.technology = res;
            this.loading = false;
          }
        });
      });
    },

    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Sets a placeholder image in the element.
     * @param {*} e  - The element where the placeholder image is to be set.
     */
    setAltImg(e) {
      e.target.src = require("../../../../assets/tech-placeholder.png");
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/search/technologysearch/detail/technologydetail.js